import { render, staticRenderFns } from "./session-popup.vue?vue&type=template&id=84271c60&"
import script from "./session-popup.vue?vue&type=script&lang=js&"
export * from "./session-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports